import { Dispatch } from "redux";
import { LoginService } from "../../services/LoginService";
import { donorapi } from "../../ApiNames";
export const fetchDataSuccess=(data:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchviewdataSuccess=(dataview:any) =>({
    type: 'FETCH_DATA_VIEW_SUCCESS',
    payload: dataview,
});

export const fetchdata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid, q :1 };
            const apiname = donorapi.feedbacks;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const viewdata = (uid:any,Feedback_id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,feedbackid:Feedback_id,q:2};
            const apiname = donorapi.feedbacks;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchviewdataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};